var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneBook2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.4553 6.04725C11.3158 6.04725 10.3907 6.9611 10.3907 8.10059C10.3907 9.22879 11.3271 10.1539 12.4553 10.1539C13.5835 10.1539 14.5086 9.24008 14.5086 8.10059C14.5086 6.9611 13.5948 6.04725 12.4553 6.04725Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.64513 0H18.2544C20.319 0 22 1.68103 22 3.74564V18.2544C22 20.319 20.319 22 18.2544 22H6.64513C4.58051 22 2.89949 20.319 2.89949 18.2544V16.201H0.846154C0.38359 16.201 0 15.8287 0 15.3549C0 14.881 0.38359 14.5087 0.846154 14.5087H2.89949V11.8462H0.846154C0.38359 11.8462 0 11.4738 0 11C0 10.5262 0.38359 10.1538 0.846154 10.1538H2.89949V7.49128H0.846154C0.38359 7.49128 0 7.10769 0 6.64513C0 6.18256 0.38359 5.79897 0.846154 5.79897H2.89949V3.74564C2.89949 1.68103 4.58051 0 6.64513 0ZM16.201 8.10051C16.201 6.02462 14.52 4.35487 12.4554 4.35487C10.3795 4.35487 8.69846 6.0359 8.69846 8.10051C8.69846 10.1651 10.3908 11.8462 12.4554 11.8462C14.52 11.8462 16.201 10.1764 16.201 8.10051ZM19.9805 18.4462C20.3528 18.7056 20.8605 18.6267 21.1313 18.2656C21.4246 17.8821 21.3344 17.3179 20.9395 17.0585C15.7949 13.6513 9.10462 13.6513 3.96 17.0585C3.56513 17.3179 3.48615 17.8821 3.76821 18.2656C4.03897 18.6267 4.53539 18.6944 4.91897 18.4462C9.48821 15.4338 15.4113 15.4338 19.9805 18.4462Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneBook2);
export default __webpack_public_path__ + "static/media/phone_book2.e1c5ea116af048df76731b0526dd424f.svg";
export { ForwardRef as ReactComponent };